import React from 'react';
import Button from './ui/Button';
import { SITE } from '../constants/site';

function HeroSection() {
  return (
    <header
      className="relative flex min-h-[100svh] w-full items-center justify-center bg-slate-900 bg-cover bg-center text-center"
      style={{ backgroundImage: `url(/photos/cover.jpeg)` }}
      id="hero"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/75 via-slate-900/45 to-slate-950/80" aria-hidden />

      <div className="relative z-10 mx-auto max-w-4xl px-6 pt-24 pb-16 md:pt-28">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-optical-200">{SITE.businessName}</p>
        <h1 className="mt-4 font-display text-4xl font-semibold tracking-tight text-white drop-shadow-sm sm:text-5xl md:text-6xl lg:text-7xl">
          {SITE.heroTitle}
        </h1>
        <p className="mt-6 text-lg font-normal text-slate-100 md:text-2xl md:leading-relaxed">{SITE.tagline}</p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button variant="primary" className="min-w-[200px]" href="#store-info">
            Visit our store
          </Button>
          <Button
            variant="secondary"
            className="min-w-[200px] !border-white/30 !bg-white/10 !text-white backdrop-blur-sm hover:!border-white/50 hover:!bg-white/20"
            href={`tel:${SITE.phone.tel}`}
          >
            Call {SITE.phone.display}
          </Button>
        </div>
      </div>
    </header>
  );
}

export default HeroSection;
